<template>
  <div>
    <el-table :data="members" stripe style="width: 100%">
      <el-table-column prop="profile.firstName" label="First Name" min-width="100">
      </el-table-column>
      <el-table-column prop="profile.lastName" label="Last Name" min-width="100"> </el-table-column>
      <el-table-column prop="profile.dob" label="DOB" min-width="100"> </el-table-column>
      <el-table-column prop="profile.email" label="Email" min-width="220">
        <template slot-scope="scope">
          <a
            class="tw-text-blue-700 tw-underline"
            target="_blank"
            :href="`mailto:${scope.row.profile.email}`"
            >{{ scope.row.profile.email }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="profile.mobile" label="Mobile" width="120">
        <template slot-scope="scope">
          <a
            class="tw-text-blue-700 tw-underline"
            target="_blank"
            :href="`tel:${scope.row.profile.mobile}`"
            >{{ scope.row.profile.mobile }}</a
          >
        </template>
      </el-table-column>
      <el-table-column label="" width="auto" min-width="85">
        <template slot-scope="scope">
          <el-link
            :underline="false"
            type="text"
            size="small"
            icon="el-icon-view"
            @click="goDetails(scope.row)"
            >Details</el-link
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "MyMembers",
  data() {
    return {
      members: [],
    };
  },
  mounted() {
    this.$store.commit("root/loading", true);
    this.$http
      .get("/nrl/api/v1/admin/members/my-members/manager")
      .then((response) => {
        this.members = response.data.data;
        this.$store.commit("root/loading", false);
      })
      .catch((error) => {
        this.$customError(_.get(error, "response.data.message"));
        this.$store.commit("root/loading", false);
      });
  },
  methods: {
    goDetails(member) {
      const { _id } = member;
      this.$router.push({
        name: "my-members.details",
        params: {
          id: _id,
        },
      });
    },
  },
  computed: {
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
  },
};
</script>

<style scoped lang="scss"></style>
